(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookVersionDeleteController',HandbookVersionDeleteController);

    HandbookVersionDeleteController.$inject = ['$uibModalInstance', 'entity', 'HandbookVersion'];

    function HandbookVersionDeleteController($uibModalInstance, entity, HandbookVersion) {
        var vm = this;

        vm.handbookVersion = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HandbookVersion.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
